// Small popover that opens when a word is clicked in either the standard
// segment view or the compact speaker-block view. Offers:
//   - Jump to audio at this word
//   - Start a new speaker from this word onwards (split)
//
// The popover is "controlled" — the parent owns the anchor state and
// closes/swaps it when the user picks an action.

import React from 'react';
import {
  ListItemIcon,
  ListItemText,
  MenuItem,
  MenuList,
  Popover,
  Tooltip,
} from '@mui/material';
import PlayArrowOutlinedIcon from '@mui/icons-material/PlayArrowOutlined';
import ContentCutOutlinedIcon from '@mui/icons-material/ContentCutOutlined';

export default function WordActionPopover({
  open,
  anchorEl,
  onClose,
  onJumpAudio,
  onSplitHere,
  splitDisabled,
  splitDisabledReason,
}) {
  const handleJump = () => {
    onJumpAudio?.();
    onClose?.();
  };
  const handleSplit = () => {
    if (splitDisabled) return;
    onSplitHere?.();
    onClose?.();
  };

  return (
    <Popover
      open={open}
      anchorEl={anchorEl}
      onClose={onClose}
      anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
      transformOrigin={{ vertical: 'top', horizontal: 'center' }}
      slotProps={{ paper: { sx: { minWidth: 240 } } }}
    >
      <MenuList dense>
        <MenuItem onClick={handleJump}>
          <ListItemIcon>
            <PlayArrowOutlinedIcon fontSize="small" />
          </ListItemIcon>
          <ListItemText>Audio ab hier abspielen</ListItemText>
        </MenuItem>
        <Tooltip
          title={splitDisabled ? (splitDisabledReason || '') : ''}
          placement="right"
        >
          {/* span needed so Tooltip can attach a ref to the disabled MenuItem */}
          <span>
            <MenuItem disabled={splitDisabled} onClick={handleSplit}>
              <ListItemIcon>
                <ContentCutOutlinedIcon fontSize="small" />
              </ListItemIcon>
              <ListItemText>Sprecher hier trennen</ListItemText>
            </MenuItem>
          </span>
        </Tooltip>
      </MenuList>
    </Popover>
  );
}
